import * as Sentry from '@sentry/nuxt';

import { name, version } from './package.json';
import { getEnvironment } from '@sub/utils/configs';

Sentry.init({
  dsn: 'https://8c17a6d2b14537eb0e8dfc8fc5313e74@sentry.cue.onl/5',
  release: name + '@' + version,
  enabled: process.env.NODE_ENV !== 'development',
  environment: getEnvironment(),
  maxValueLength: 10000,
  normalizeDepth: 5,
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});